















































































































































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import TicketService from "@/services/TicketService";
import SubmitTicketButtonGroupMobile from "@/view/shared-components/mobile-only/SubmitTicketButtonGroupMobile.vue";
import SubmitTicketButtonGroupDesktop from "@/view/shared-components/desktop-only/SubmitTicketButtonGroupDesktop.vue";
import alertMixin from "@/mixins/alert-mixin";
import WipTicket from "../../../domainObjects/wip/WipTicket";
import WipActionItems from "../../../domainObjects/wip/WipActionItems";
import WipActionTracker from "@/view/wip/components/WipActionTracker.vue";
import {mapGetters} from "vuex";
import LoadingActions from "@/store/actions/loading";


@Component({
    components: {
        WipActionTracker,
        SubmitTicketButtonGroupDesktop,
        SubmitTicketButtonGroupMobile,
    },
    mixins: [alertMixin],
    computed: {
        // TODO: should change to mapState at some point
        ...mapGetters(['getFirstName', 'getLastName', 'getGroups']),
    }
})
export default class ViewWipTicketPage extends Vue {
    private ticketId:number = 0;
    private wipTicket:WipTicket = new WipTicket();
    private originalWipTicketStringified: string = "";
    private ticketChanged: boolean = false;
    private buttonVariant: string = 'outline-secondary';
    private submitButtonText: string = 'Save';
    private errorMessage: string = '';
    private piecesRemaining: number = 0;
    private getFirstName!: string;
    private getLastName!: string;
    private wipActionItems: WipActionItems = new WipActionItems();
    $_alertMixin_swalConfirm!: (heading: string | null, message: string | null, type: string | null) => Promise<boolean>;
    $_alertMixin_swalClose!: (heading: string | null, message: string | null, type: string | null) => Promise<boolean>;
    $_alertMixin_saveSuccess!: () => void;

    @Watch('wipTicket', { immediate: true, deep: true})
    onPropertyChanged(value:WipTicket, oldvalue: WipTicket){
        let newWipTicketStringified = JSON.stringify(value);
        this.ticketChanged = this.originalWipTicketStringified !== newWipTicketStringified;
        if (this.ticketChanged){
            this.buttonVariant = 'secondary';
        } else {
            this.buttonVariant = 'outline-secondary'
        }
    }

    constructor(){
        super()
    }

    created() {
        this.getTicket();
    }

    addRow(){
        let newActionItem = new WipActionItems();
        newActionItem.wipTicketId = this.wipTicket.wipTicketId;
        this.wipTicket.wipActionItems.unshift(newActionItem);
    }

    recalculateTotalQty() {
        let totalQty:number = 0;
        for (let i = 0; i < this.wipTicket.wipActionItems.length; i++){
            if (!this.wipTicket.wipActionItems[i].quantity)
                this.wipTicket.wipActionItems[i].quantity = 0;
            totalQty += parseInt(String(this.wipTicket.wipActionItems[i].quantity));
        }
        this.piecesRemaining = this.wipTicket.qtyOnHold - totalQty;
        if (this.piecesRemaining === 0 && this.wipTicket.status.desc === 'Open') {
            this.submitButtonText = 'Close Ticket';
        } else {
            this.submitButtonText = 'Save';
        }
    }


    actionTrackerIsValid(){
        this.errorMessage = "";
        for (let i = 0; i < this.wipTicket.wipActionItems.length; i++){
            if (this.wipTicket.wipActionItems[i].wipActionItemShift.length === 0 ||
                this.wipTicket.wipActionItems[i].skidNo.length ===0 ||
                this.wipTicket.wipActionItems[i].wipActionCompletedBy.length === 0 ||
                this.wipTicket.wipActionItems[i].location.length === 0 ||
                this.wipTicket.wipActionItems[i].wipActionItemDate === ""
            ){
                this.errorMessage = "Missing required fields";
                return false
            }
        }
        return true
    }

    onSubmit(){
        let self = this;
        this.recalculateTotalQty();
        if (this.actionTrackerIsValid()) {
            if (this.piecesRemaining === 0 && this.errorMessage.length === 0 && this.wipTicket.status.desc === 'Open') {
                this.wipTicket.closedBy = this.getFirstName + ' ' + this.getLastName;
                this.wipTicket.closedDate = Date.now();
                this.$_alertMixin_swalClose('Close Ticket?', null, null).then((value) => {
                    if (value) {
                        let wipTicketJSON = JSON.stringify(self.wipTicket);
                        TicketService.closeWipTicket(wipTicketJSON).then((response) => {
                            self.$_alertMixin_saveSuccess();
                            // @ts-ignore
                            this.$router.push({name: 'wip-tickets', params: {updatedTicket: this.wipTicket, updatedTicketType:'closed'}})
                            //self.getTicket()
                        }).catch((error) => {
                            self.getTicket()
                        })
                    }
                })
            } else {
                this.$_alertMixin_swalConfirm('Save Action Items', this.errorMessage, null).then((value) => {
                    if (value) {

                        let wipActionItemsJSON = JSON.stringify(self.wipTicket.wipActionItems);
                        TicketService.saveWipActionItems(wipActionItemsJSON).then((response) => {
                            self.$_alertMixin_saveSuccess();
                            // @ts-ignore
                            this.$router.push({name: 'wip-tickets', params: {updatedTicket: this.wipTicket, updatedTicketType:'updated'}})
                            //self.getTicket();
                        }).catch((error) => {
                            self.getTicket();
                        })
                    }
                })
            }
        }
    }
    onReset(){
        this.errorMessage = "";
        this.wipTicket.loaded = false;
        this.$nextTick(()=>{
            this.getTicket();
            this.wipTicket.loaded = true;
        })
    }

    getTicket(){
        this.$store.dispatch(LoadingActions.LOADING, true);
        this.ticketId = parseInt(this.$route.params['wipTicketId']);
        TicketService.getWipTicketById(this.ticketId).then((response)=>{
            this.wipTicket = new WipTicket();
            this.wipTicket.initFromObject(response.data);
            this.wipTicket.loaded = true;
            this.originalWipTicketStringified = JSON.stringify(this.wipTicket);
            this.recalculateTotalQty()
            this.$store.dispatch(LoadingActions.LOADING, false);
        }).catch((error)=>{
        });
    }
}
